// Copyright (c) 2019 Deere & Company

import alertsReducer from '../../sharedmodules/reducer/alerts';
import busyCounter from '../../sharedmodules/reducer/busy-counter';
import { combineReducers } from 'redux';
import { createTransferCombineReducer } from '../product-settings/new-transfer/reducers/create-transfer-combineReducer';
import { duplicatePinPlateCombineReducer } from '../duplicate-pin-plate-settings/duplicate-pin-plate-combine-reducer';
import latestPerUnitMeasurements from '../product-settings/shared/reducers/latest-per-unit-measurements';
import modalReducer from '../../sharedmodules/reducer/modalReducer';
import notificationsReducer from '../notifications/reducer/notifications';
import { pinSearchCombineReducer } from '../product-settings/pin-search-combine-reducer';
import { pinTransferCombineReducer } from '../pin-transfer-settings/pin-transfer-setting-combine-reducer';
import { productDealerSearch } from '../product-settings/dealer-search/reducers';
import { userSettingsCombineReducer } from '../users-settings/user-setting-combine-reducer';

export const getApplicationReducers = () => combineReducers({
    busyCounter,
    alerts: alertsReducer,
    createTransfer: createTransferCombineReducer(),
    duplicatePinPlateSetting: duplicatePinPlateCombineReducer(),
    latestPerUnitMeasurements,
    notifications: notificationsReducer,
    modal: modalReducer,
    pinSearchSetting: pinSearchCombineReducer(),
    pinTransfersetting: pinTransferCombineReducer(),
    productDealerSearch: productDealerSearch(),
    userSettings: userSettingsCombineReducer(),

});
